import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";

import { AlertService, EmployeeService } from "../../_services";

@Component({ templateUrl: "employee.list.html" })
export class EmployeeList implements OnInit, OnDestroy {
  heading = "Employees";
  subheading = "";
  icon = "fa fa-users icon-gradient bg-happy-itmeo";
  link = "/employee/add";
  employees: [];
  dataSource: MatTableDataSource<any[]>;
  search_key = "";
  pageSizeOptions = null;
  displayedColumns = ["s_no", "employee_name", "employee_id", "actions"];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  constructor(
    private employeeServices: EmployeeService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.loadAllEmployees();
  }

  ngOnDestroy() {}

  clearFilters() {
    this.dataSource.filter = "";
    this.search_key = "";
  }

  private loadAllEmployees() {
    this.employeeServices
      .getAll()
      .pipe(first())
      .subscribe((employees: any) => {
        if (employees.status == "ok") {
          this.dataSource = new MatTableDataSource(employees.result_set);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  deleteEmployee(id: number) {
    this.alertService.delete().then(data => {
      if (data) {
        this.employeeServices
          .delete(id)
          .pipe(first())
          .subscribe((data: any) => {
            if (data.status == "ok") {
              this.alertService.success(data.message, true);
              this.loadAllEmployees();
            } else {
              this.alertService.error(data.message, true);
            }
          });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
